export const keys = {
  chats: 'chats',
  cartItems: 'cartItems',
  msgNumberString: 'msgNumberString',
  latestEmojiKey: 'latestEmojiKey',
  tokens: 'tokens',
  currentUser: 'currentUser',
  myWorldUnreadPosts: 'myWorldUnreadPosts',
  registration: 'registration',
  selectedSkinTone: 'selectedSkinTone',
  notifications: 'notifications',
  smsSent: 'smsSent',
  composedMsgsData: 'composedMsgsData',
  composedCommentsData: 'composedCommentsData',
  publiGroupsLocale: 'publiGroupsLocale',
  logout: 'logout', // used for having logout on all tabs
  needTosAccepted: 'needTosAccepted', // consumer only, SG-17628
  tosAcceptedTime: 'tosAcceptedTime', // BE caches tos-acceptance value so this is needed to avoid spamming user with tos popups
  purchasedItems: 'purchasedItems',
  desktopSettings: 'desktopSettings',
  chatFilter: 'chatFilter',
  entriesMarkSeen: 'entriesMarkSeen',
  paypalTransactionStatus: 'paypalTransactionStatus',
  titleCount: 'titleCount',
  filterFavoritesInContacts: 'filterFavoritesInContacts',
  sessionData: 'sessionData',
  internalToolsEnabled: 'internalToolsEnabled',
  unmuteVideos: 'unmuteVideos',
  videoFeedAutoPlaySetting: 'videoFeedAutoPlaySetting',
  allowNsfwContentSetting: 'allowNsfwContentSetting',
  trendingHashtagExpanded: 'trendingHashtagExpanded',
  clickedCampaigns: 'clickedCampaigns',
  pendingVideoChatJobs: 'pendingVideoChatJobs',
  pendingVideoPostJobs: 'pendingVideoPostJobs',
};

// the keys below should remain in storage to avoid losing their information on logout`
export const keysShouldRemainInStorage = [
  'videoFeedAutoPlaySetting',
  'allowNsfwContentSetting',
  'trendingHashtagExpanded',
  'showDebugDialog',
  'internalToolsEnabled',
];

// no "userId" suffix for these keys
export const keysWithoutSuffix = [
  'needTosAccepted',
  'tosAcceptedTime',
  'notifications',
  'currentUser',
  'registration',
  'selectedSkinTone',
  'logout',
  'smsSent',
  'sessionData',
  'internalToolsEnabled',
  'videoFeedAutoPlaySetting',
  'allowNsfwContentSetting',
  'trendingHashtagExpanded',
  'trc',
];
